const ClientProtectionContentFour = () => {
  const tradingSteps = [
    {
      step: "Advanced Account Security Controls",
      title:
        "Your trading account is protected by multiple layers of authentication and security monitoring. ",
      // description:
      //   "Register an Exness Personal Area by clicking 'Try free demo' on this page.",
    },
    {
      step: "Responsible Trading Safeguards",
      title:
        "Protection isn’t just about keeping your data safe, it’s also about shielding you from excessive risk.",
      // description:
      //   "Click 'Demo account' and get a Standard MT5 demo account with $10,000 demo balance.",
    },
  ];

  return (
    <div className="trading-guide-section">
      <div className="trading-container">
        <div className="trading-header-row">
          <h2 className="trading-main-headline">
            More Ways We Keep You Protected
          </h2>
          <p>
            Beyond platform and payment security, we reinforce your trading
            environment with layers of protection designed to secure your
            identity, your data, and your decision-making
          </p>
        </div>

        <div className="trading-visual-wrapper">
          <div className="trading-bg-image-position-center">
            <img
              src="/images/trading/client_protection/client_protection_3.png"
              alt="Trading Demo Account User"
            />
          </div>

          <div className="trading-cards-container">
            <div className="trading-cards-row">
              {tradingSteps.map((item, index) => (
                <div className="trading-step-card" key={index}>
                  <span className="trading-step-number">{item.step}</span>
                  <h3 className="trading-card-title">{item.title}</h3>
                  {/* <p className="trading-card-desc">{item.description}</p> */}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientProtectionContentFour;
